export default __webpack_public_path__ + "static/GhostPadding-bdcdfdc03bd656990cb2dc1912b17eaf.png";